<div class="form-group" [formGroup]="form">
    <label for="id_{{label}}" *ngIf="label">
        {{label}}:
        <span *ngIf="requerido" class="text-danger" style="font-size: 12px;">(*)</span>
    </label>
    <input type="text" formControlName="{{modelo}}" class="form-control" name="{{modelo}}" id="id_{{label}}"
        step="{{step}}" placeholder="{{placeholder}}" (keypress)="validar($event) " [max]="max" [min]="min"
         [ngClass]="{'is-invalid':form.get(modelo).invalid  && form.get(modelo).touched}">
    <app-input-validation [control]="form.get(modelo)" [modelo]="modelo" [label]="show" *ngIf="requerido"></app-input-validation>
</div>